<template>
    <div class="row mb-3">
        <label :class="'col-form-label col-sm-' + labelCols" :for="field.id">{{ field.label }}{{
                field.required ? '*' : ''
            }}</label>
        <div :class="'col-sm-' + fieldCols">
            <input :id="field.id"
                   :disabled="field.locked"
                   :placeholder="field.placeholder"
                   :required="field.required"
                   :value="value"
                   class="form-control"
                   type="text"
                   v-on:input="$emit('update:modelValue', $event.target)"/>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        field: {
            type: Object,
            required: true
        },
        value: {
            type: String,
            required: false,
            defaultValue: ''
        },
        fieldCols: {
            type: String,
            required: true
        },
        labelCols: {
            type: String,
            required: true
        }
    }
}
</script>